export type NavigatorResultsRole = 'care-seeker' | 'fp';

export type NavigatorResultsCopy = {
  careStageEyebrow: string;
  emptyCategories: string;
  /**
   * Empty-category message (docs/prototypes/no_providers_found_message.md):
   * instead of a dead-end "no providers found", hand the user to the Care
   * Concierge. CTA uses `conciergeCtaLabel` and renders when the surface wires
   * `onConciergeRequest` (FP ResultsPage, CareSeekerResults, SharedCarePlanView).
   */
  noProvidersConciergeMessage: string;
  /** Label for the empty-specialty Care Concierge button. */
  conciergeCtaLabel: string;
  keyResourcesTitle: string;
  /** Chip on the featured card when the selection is still the AI top match. */
  topMatchChip: string;
  /** Chip on the featured card after the user swapped away from the top match. */
  selectionChip: string;
  /** Micro-label above the AI rationale callout. */
  whyThisMatchLabel: string;
  /** Alt-row action that makes that provider the specialty's selection. */
  selectButtonLabel: string;
  /** Warm one-liner when the care-stage card has no summary bullets (guest). */
  careStageFallbackLine: string;
  /** Toast when an optimistic selection swap fails to persist. */
  selectionSaveFailed: string;
};

export const navigatorResultsCopy: Record<NavigatorResultsRole, NavigatorResultsCopy> = {
  'care-seeker': {
    careStageEyebrow: 'Your Care Stage',
    emptyCategories: 'No provider categories were matched to your care stage.',
    noProvidersConciergeMessage:
      'Your situation is unique, and we want to ensure that you get the perfect provider for your needs. Our system is indicating that our Care Concierge team should step in to help you with this specialist.',
    conciergeCtaLabel: 'Contact Care Concierge',
    keyResourcesTitle: 'Key Resources',
    topMatchChip: 'Top Match',
    selectionChip: 'Your Selection',
    whyThisMatchLabel: 'Why this match',
    selectButtonLabel: 'Select',
    careStageFallbackLine: 'We shaped this guide around what you shared with us.',
    selectionSaveFailed: "Couldn't save your selection. Please try again.",
  },
  fp: {
    careStageEyebrow: "Your Client's Care Stage",
    emptyCategories: 'No provider categories were matched to this care stage.',
    noProvidersConciergeMessage:
      "Your client's situation is unique, and we want to ensure you get the perfect provider for your client's needs. Our system is indicating that our Care Concierge team should step in to help with this specialist.",
    conciergeCtaLabel: 'Contact Care Concierge',
    keyResourcesTitle: 'Key Resources',
    topMatchChip: 'Top Match',
    selectionChip: 'Plan Selection',
    whyThisMatchLabel: 'Why this match',
    selectButtonLabel: 'Select',
    careStageFallbackLine: "We shaped this guide around what your client shared.",
    selectionSaveFailed: "Couldn't save the plan selection. Please try again.",
  },
};
